import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getPressMedia} from '../utils/endpoints'
import { Container } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { Helmet } from 'react-helmet';
import Check from '../assets/svg/Check';
import Cross from '../assets/svg/cross';

const TicketsOffers = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [pressMediaData, setPressMediaData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const pressMediaData = await getPressMedia(id);
            setPressMediaData(pressMediaData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      <Helmet>
      <title>Nathdwara shiva statue timings | nathdwara famous for</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>Tickets & Offers</li>
            </ul>
            <h1>Tickets & Offers</h1>
          </Container>
        </section>
        <Container className='pt-5'>
          <p><b>Ticket price for age above 12 years</b> :</p>
        <div className="table-responsive">
          <table className='table table-bordered'>
            <thead>
              <tr>
                <th>Ticket Type(For Indian Citizens)</th>
                <th>Price</th>
                </tr>
            </thead>
            <tbody>
              <tr>
              <td>
                Park Entry
              </td>
              <td>200</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge 
              </td>
              <td>400</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge + Jalabshek(351 Ft.)
              </td>
              <td>1500</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge <b>(Express)</b>
              </td>
              <td>800</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='ticket-note mb-5'><p>Please refer booking portal for any price variation.</p></div>

        <p className='mt-5'><b>Ticket prices for children aged 4-12</b> :</p>
        <div className="table-responsive">
          <table className='table table-bordered'>
            <thead>
              <tr>
                <th>Ticket Type(For Indian Citizens)</th>
                <th>Price</th>
                </tr>
            </thead>
            <tbody>
              <tr>
              <td>
                Park Entry
              </td>
              <td>100</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge 
              </td>
              <td>200</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge + Jalabshek(351 Ft.)
              </td>
              <td>750</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge <b>(Express)</b>
              </td>
              <td>400</td>
              </tr>
              
            </tbody>
          </table>
        </div>

        <div className='ticket-note mb-5'><p>Please refer booking portal for any price variation.</p></div>
        <p><b>Ticket price for age above 12 years</b> :</p>
        <div className="table-responsive">
          <table className='table table-bordered'>
            <thead>
              <tr>
                <th>Ticket Type(Foreign Citizen)</th>
                <th>Price</th>
                </tr>
            </thead>
            <tbody>
              <tr>
              <td>
                Park Entry
              </td>
              <td>300</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge
              </td>
              <td>500</td>
              </tr>
              
            </tbody>
          </table>
        </div>
        <div className='ticket-note mb-5'><p>Please refer booking portal for any price variation.</p></div>
        <p><b>Ticket prices for children aged 4-12</b> :</p>
        <div className="table-responsive">
          <table className='table table-bordered'>
            <thead>
              <tr>
                <th>Ticket Type(Foreign Citizen)</th>
                <th>Price</th>
                </tr>
            </thead>
            <tbody>
              <tr>
              <td>
                Park Entry
              </td>
              <td>150</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge 
              </td>
              <td>250</td>
              </tr>
              <tr>
              <td>
                Park Entry + 280 Ft. + 270 Ft. +  Glass Bridge + Jalabshek(351 Ft.)
              </td>
              <td>1000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='ticket-note mb-5'><p>Please refer booking portal for any price variation.</p></div>

        <p className='d-none'><b>TICKET COMBOS(SUMMER BONANZA OFFER PRICES)</b> :</p>
        <div className="table-responsive d-none">
          <table className='table table-bordered table-striped table-hover tableCombo'>
            <thead>
              <tr>
                <th>Combo Code</th>
                <th>Combo Title</th>
                <th>Services Included</th>
                <th>Adult Price</th>
                <th>Child Price</th>
                </tr>
            </thead>
            <tbody>
            {/* {comboData.map((item, key) => (
              <tr>
              <td>{item?.ComboCode}</td>
              <td>{item?.DisplayTitle}</td>
              <td>{item?.ComboDesc}</td>
              <td>{item?.AdultPrice}</td>
              <td>{item?.ChildPrice}</td>
            </tr>
            ))} */}
            </tbody>
          </table>
          </div>
          <div className='ticket-note mb-5 d-none'><p>Please refer booking portal for any price variation.</p></div>
        <div className="table-responsive d-none">
          <table className='table table-bordered table-striped table-hover tableCombo'>
            <thead>
              <tr>
                <th>Ticket Type/Price (1 Adult)</th>
                <th class="text-center">₹500</th>
                <th class="text-center">₹600</th>
                <th class="text-center">₹700</th>
                <th class="text-center">₹800</th>
                <th class="text-center">₹850</th>
                <th class="text-center">₹1000</th>
                <th class="text-center">₹1500</th>
                </tr>
            </thead>
            <tbody>
              <tr>
              <td class="verticle-middle">
                Park Entry
              </td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              Viewing Gallery 280-270ft.
              </td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              Kailasha Snow Park
              </td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              Wax Museum + Infinity Room
              </td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              Eyelusion + Upside Down Room
              </td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              5 Amusement Rides/Kidszone
              </td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              5 Adventure Rides
              </td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              <td><span><Check /></span></td>
              <td><span className='cross'><Cross /></span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
              Cart/Train Drop
              </td>
              <td><span>1 Time</span></td>
              <td><span>1 Time</span></td>
              <td><span>1 Time</span></td>
              <td><span>1 Time</span></td>
              <td><span>3 Time</span></td>
              <td><span>3 Time</span></td>
              <td><span>3 Time</span></td>
              </tr>
              <tr>
              <td class="verticle-middle">
                JALABHISHEK
              </td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span className='cross'><Cross /></span></td>
              <td><span><Check /></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default TicketsOffers;